import { useEffect, useState } from 'react';

const mobileActionsQuery = '(max-width: 767px), (max-width: 1024px) and (max-height: 500px)';

/** Keep action geometry and its rendered dimensions in sync when resizing. */
export function useDigitalMapActionSize() {
  const [mobile, setMobile] = useState(() => window.matchMedia?.(mobileActionsQuery).matches ?? false);
  useEffect(() => {
    const media = window.matchMedia?.(mobileActionsQuery);
    if (!media) return;
    const update = () => setMobile(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, []);
  return mobile ? 56 : 28;
}
